module.exports = __webpack_public_path__ + "media/images/badgerart01-f4c9fe61f75df66895cf2bf77048144b.png";